import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent } from '@guildeducationinc/recess';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { CommunicationContentsList } from '@src/components/Admin/CommunicationContent';
import { ContentType, useContents, useLocale } from 'pe-core-frontend';
import { useParams } from 'react-router-dom';
export const Communications = () => {
    const { t } = useLocale();
    const { tab = 'employees' } = useParams();
    const { contents, refetch } = useContents({
        contentType: ContentType.EMAIL,
        includeInactive: true,
    });
    const handleDelete = () => {
        refetch();
    };
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Emails'), navLinks: [
                    {
                        title: t('To Employees'),
                        path: '/admin/comms/employees',
                        selected: tab === 'employees',
                    },
                    {
                        title: t('To Approvers'),
                        path: '/admin/comms/approvers',
                        selected: tab === 'approvers',
                    },
                ] }), _jsx("div", { children: _jsx(Card, { children: _jsx(CardContent, { children: _jsx(CommunicationContentsList, { contents: contents || [], onDelete: handleDelete, tab: tab }) }) }) })] }));
};
